// Utilidades para manejo de tokens JWT
export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp && payload.exp < now;
  } catch (error) {
    console.error('Error verificando expiración del token:', error);
    return true;
  }
};

export const getTokenExpirationTime = (token) => {
  if (!token) return null;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp ? new Date(payload.exp * 1000) : null;
  } catch (error) {
    console.error('Error obteniendo tiempo de expiración:', error);
    return null;
  }
};

export const getTimeUntilExpiration = (token) => {
  const expirationTime = getTokenExpirationTime(token);
  if (!expirationTime) return 0;
  
  const now = new Date();
  const timeDiff = expirationTime.getTime() - now.getTime();
  return Math.max(0, Math.floor(timeDiff / 1000)); // segundos hasta expiración
};

export const shouldRefreshToken = (token, refreshThresholdMinutes = 5) => {
  const timeUntilExpiration = getTimeUntilExpiration(token);
  const thresholdSeconds = refreshThresholdMinutes * 60;
  return timeUntilExpiration <= thresholdSeconds && timeUntilExpiration > 0;
};

export const clearAllTokens = () => {
  console.log('🧹 Limpiando todos los tokens...');
  
  // Limpiar tokens principales
  sessionStorage.removeItem('cognitoToken');
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('refreshToken');
  sessionStorage.removeItem('userEmail');

  // Limpiar localStorage también por seguridad
  localStorage.clear();
  
  console.log('✅ Todos los tokens y datos limpiados');
};

export default {
  isTokenExpired,
  getTokenExpirationTime,
  getTimeUntilExpiration,
  shouldRefreshToken,
  clearAllTokens
};
